import React from "react";
import { useSelector } from "react-redux";
import ItemBlock from "../../../../components/sections/ContestInfo/itemBlock/ItemBlock";
import ZoomButton from "../../../../components/ui/buttons/ZoomButton";
import YouTubeLogo from "../../../../components/ui/youtubeLogo/YouTubeLogo";
import DownloadImg from "./DownloadImg/DownloadImg";
import classes from "./FinalPrepareSection.module.css";

const FinalPrepareSection = () => {

  const { texts } = useSelector((state) => state.translate);
  const { contentInfoJson } = useSelector((state) => state.contest);

  return (
    <ItemBlock className={classes.wrapper}>
      <div className={classes.header}>
        <p className={classes.headerTitle}>{texts?.finalPagePrepareForBroadcast}</p>
        <YouTubeLogo className={classes.youtubeLogo} link={contentInfoJson?.final?.linkYouTube} />
      </div>
      <div className={classes.prepareContent}>
        <div className={classes.zoomBlock}>
          <p className={classes.zoomTitle}>{texts?.finalPageJoinZoom}</p>
          <ZoomButton text={texts?.finalPageJoinZoomButton} link={contentInfoJson?.final?.linkZoom} />
          <p className={classes.zoomInfoText}>{texts?.zoomRoomInfoText}</p>
        </div>
        <div className={classes.downloadImages}>
          {contentInfoJson?.final?.backgroundImages?.map((item, index) => (
            <DownloadImg key={index} img={item} />
          ))}
        </div >
      </div>
    </ItemBlock >
  );
};

export default FinalPrepareSection;
